// src/components/modals/PurchaseSuccessModal.jsx
import React, { useEffect } from 'react';
import { BookOpen, GraduationCap, Scroll, Sparkles, Gift, Shirt } from 'lucide-react';
import { playSound } from '../../utils/sounds';

export default function PurchaseSuccessModal({ type, title, onClose, autoClose = true }) {
  useEffect(() => {
    playSound('vocabcompra');
    
    if (autoClose) {
      const timer = setTimeout(onClose, 1500);
      return () => clearTimeout(timer);
    }
  }, [onClose, autoClose]);

  const getConfig = () => {
    switch (type) {
      case 'review':
        return { 
          icon: GraduationCap, 
          color: 'text-purple-400', 
          shadow: 'shadow-purple-500/50',
          label: '¡EXAMEN DESBLOQUEADO!' 
        };
      case 'reading':
        return { 
          icon: Scroll, 
          color: 'text-blue-400', 
          shadow: 'shadow-blue-500/50',
          label: '¡LECTURA DISPONIBLE!' 
        };
      case 'mystery':
        return { 
          icon: Gift, 
          color: 'text-pink-400', 
          playSound: 'vocabcompra',
          shadow: 'shadow-pink-500/50',
          label: '¡ZONA MISTERIOSA ABIERTA!' 
        };
      case 'skin':
        return { 
          icon: Shirt, 
          color: 'text-emerald-400', 
          shadow: 'shadow-emerald-500/50',
          label: '¡NUEVA SKIN OBTENIDA!' 
        };
      default:
        return { 
          icon: BookOpen, 
          color: 'text-amber-400', 
          shadow: 'shadow-amber-500/50',
          label: '¡CONTENIDO LIBERADO!' 
        };
    }
  };

  const config = getConfig();
  const IconComponent = config.icon;

  return (
    <div 
      className="fixed inset-0 z-[300] bg-slate-950/95 backdrop-blur-2xl flex items-center justify-center p-4 sm:p-6 animate-in fade-in duration-500"
      onClick={type === 'skin' ? onClose : undefined}
    >
      
      {/* ✅ Fondo animado con tamaño controlado */}
      <div className="absolute w-[400px] h-[400px] sm:w-[600px] sm:h-[600px] lg:w-[800px] lg:h-[800px] bg-[conic-gradient(from_0deg,transparent_0deg,rgba(255,255,255,0.05)_20deg,transparent_50deg)] animate-spin-slow rounded-full opacity-50" />

      {/* ✅ Contenedor con máximo ancho */}
      <div className="relative z-10 w-full max-w-xs sm:max-w-md flex flex-col items-center">
        
        {/* ✅ Ícono responsivo */}
        <div className={`animate-magic-book ${config.color} drop-shadow-[0_0_50px_rgba(255,255,255,0.3)]`}>
          <IconComponent className="w-20 h-20 sm:w-28 sm:h-28 lg:w-36 lg:h-36" />
        </div>

        {/* ✅ Textos responsivos */}
        <div className="mt-8 sm:mt-12 space-y-2 sm:space-y-3 w-full px-4">
          <div className="flex items-center justify-center gap-2">
            <Sparkles className="text-yellow-400 animate-pulse w-4 h-4 sm:w-5 sm:h-5" />
            <span className="text-white/60 font-black uppercase tracking-[0.3em] text-[9px] sm:text-[10px]">
              {config.label}
            </span>
            <Sparkles className="text-yellow-400 animate-pulse w-4 h-4 sm:w-5 sm:h-5" />
          </div>
          
          <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-black italic tracking-tighter uppercase leading-none break-words">
            {title}
          </h2>
          
          <p className="text-indigo-300 font-bold text-sm sm:text-base lg:text-lg animate-pulse">
            ¡Disfruta tu recompensa!
          </p>
          
          {type === 'skin' && (
            <p className="text-white/40 text-xs mt-3 sm:mt-4 animate-bounce">
              Toca para continuar
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
